<template>
  <main class="styles-app-structure-main" :class="($route.params.event) ? 'event-opened' : ''">
    <nav id="sidebar" @mouseover="hover()" @mouseleave="unhover()"  :class="(compact) ?
       (hovered) ? 'styles-app-structure-nav-compact' : 'styles-app-structure-nav-compact' : 'styles-app-structure-nav'">
      <div class="styles-app-structure-nav-container">
        <div :class="(compact) ? 'Navigation-styles-navigation-container-compact' : 'Navigation-styles-navigation-container'">
          <img v-show="!compact" @click="closeCompact" class="styles-app-structure-resize-nav-tree" src="/static/assets/img/arrow-double-left.svg">
          <img v-show="compact" @click="clickCompact" class="styles-app-structure-resize-nav-tree" src="/static/assets/img/arrow-double-right.svg">

          <quick-links />
          <topCompetitions />
          <timer />
          <topSports />
        </div>
      </div>
    </nav>
    <section class="styles-app-structure-section">
      <div class="styles-app-structure-program" :class="($route.params.event) ? 'styles-app-structure-split' : ''">
        <matches :filter="{loadmore: true, list: 2, loadmore: 1, upcoming: $store.state.fixtureTimeperiod, regions: ($route.query.r) ? $route.query.r.split(',') : null,competitions: ($route.query.c) ? $route.query.c.split(',') : null}" v-if="($route.query.r || $route.query.c) || $route.name === 'myFavorites'" :onLive="false" refs="matches"/>
        <upcomingWidget v-if="!$route.query && $route.name !== 'myFavorites'" />
        <fixtureHome v-if="(!$route.query.r && !$route.query.c) && $route.name !== 'myFavorites'" />
      </div>
      <matchDetail v-if="$route.params.event" />


    </section>

    <aside id="aside" class="styles-app-structure-aside">

      <div class="Aside-styles-aside-wrapper">
        <betSlip />
      </div>
      <LocaleSelection />
      <betPot />

      <topRewards />


    </aside>

    <CountDownLoader />
  </main>
</template>

<script>
import fixtureHome from '@/components/sportsbook/fixtureHome';
import promoSlide from '@/components/promotion/promoSlide';
import topRewards from '@/components/sportsbook/widget/topRewards';
import upcomingWidget from '@/components/sportsbook/widget/upcoming';
import playingWidget from '@/components/sportsbook/widget/playing';
import CompetitionSide from '@/components/sportsbook/CompetitionSide';
import BetSlip from '@/components/sportsbook/BetSlip';
import LiveMatches from "../sportsbook/LiveMatches";
import LiveUpcaming from "../sportsbook/liveUpcaming";
import statsInfo from '@/components/sportsbook/widget/statsInfo'
import supportInfo from '@/components/sportsbook/widget/supportInfo';
import recommendedLinks from '@/components/sportsbook/widget/recommendedLinks'
import mobileInfo from '@/components/sportsbook/widget/mobileinfo'
import liveCasinoBanner from '@/components/sportsbook/widget/liveCasinoBanner'
import eventSearch from '@/components/sportsbook/widget/eventSearch';
import matches from '@/components/sportsbook/matches';
import matchDetail from '@/components/sportsbook/matchDetail';

import quickLinks from "../widget/quickLinks";
import topCompetitions from "../widget/topCompetitions";
import TopSports from "../widget/topSports";
import timer from "../widget/timer";
import betPot from '@/components/widget/betPot';
import CountDownLoader from '@/components/sportsbook/countdownLoader'
import LocaleSelection from '../ui/localeSelection';

export default {
  name: 'fixture',
  components: {
    CountDownLoader,
    betPot,
    matches,
    TopSports,
    timer,
    quickLinks,
    topCompetitions,
    eventSearch,
    liveCasinoBanner,
    topRewards,
    LiveUpcaming,
    LiveMatches,
    promoSlide,
    upcomingWidget,
    playingWidget,
    CompetitionSide,
    BetSlip,
    statsInfo,
    supportInfo,
    recommendedLinks,
    mobileInfo,
    matchDetail,
    fixtureHome,
    LocaleSelection
  },
  data() {
    return {
      compact: false,
      hovered: false
    }
  },
  mounted() {
    /*this.$nextTick(() => {
        const swiperTop = this.$refs.swiperTop.swiper
        const swiperThumbs = this.$refs.swiperThumbs.swiper
        swiperTop.controller.control = swiperThumbs
        swiperThumbs.controller.control = swiperTop
    })*/
    this.checkWindow()
    window.addEventListener('resize', this.checkWindow);
  },
  methods: {
    checkWindow(w) {
      if(window.innerWidth < 1200){
        this.compact = true;
        this.$bus.$emit('compact', this.compact);
      }else {
        this.compact = false;
        this.$bus.$emit('compact', this.compact);
      }

    },
    clickCompact(){
      this.compact = (this.compact) ? false : true;

      this.$bus.$emit('compact', this.compact);
    },
    closeCompact(){
      this.compact = (this.compact) ? false : true;

      this.$bus.$emit('compact', this.compact);
    },
    hover () {

      if(this.compact){
        this.hovered = (this.hovered) ? false : true;

        var element = document.getElementById('sidebar');
        element.classList.add('styles-app-structure-hovered');

        this.$bus.$emit('compact', false);
      }

    },
    unhover () {

      if(this.compact){
        this.hovered = (this.hovered) ? false : true;

        var element = document.getElementById('sidebar');
        element.classList.remove('styles-app-structure-hovered');

        this.$bus.$emit('compact', true);
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.app-container {
  display: flex;
}

.swiper-container img {
  width: 100%;
}

.swiper-slide {
  height: auto;
  background-size: 100%;
  background-position: top;
  background-repeat: no-repeat;
  &.slide-1 {
    background-image: url('/static/assets/img/slides/welcome_bonus.jpg');
  }
  &.slide-2 {
    background-image: url('/static/assets/img/slides/papara.jpg');
  }
  &.slide-3 {
    background-image: url('/static/assets/img/slides/cepbank.jpg');
  }
  &.slide-4 {
    background-image: url('/static/assets/img/slides/freebonus.jpg');
  }
  &.slide-5 {
    background-image: url('/static/assets/img/slides/norisk.jpg');
  }
  &.slide-6 {
    background-image: url('/static/assets/img/slides/payment_bonus.jpg');
  }
  &.slide-7 {
    background-image: url('/static/assets/img/slides/livecasino.jpg');
  }
}

.swiper-slide a {
  width: 100%;
  height: 100%;
  float: left;
}

.gallery-top {
  height: auto;
  width: 100%;
}

.gallery-thumbs {
  height: 140px;
  box-sizing: border-box;
  padding: 10px 0;
}

.gallery-thumbs .swiper-slide {
  width: 25%;
  height: 100%;
  opacity: 0.4;
}

.gallery-thumbs .swiper-slide-active, .gallery-thumbs:hover {
  opacity: 1;
}

.styles-app-structure-resize-nav-tree {
  position: absolute;
  right: 15px;
  top: 10px;
}

.event-opened > .styles-app-structure-nav {
    width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/sportsbook/fixture.vue